'use strict';

module.exports = '3.32.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 40
// module chunks = 0